<template>
  <div v-if="images" :class="$style.root">
    <CoreImageCarouselComponent
      v-if="images"
      :images="images"
    />
    <CoreTextComponent
      :class="$style.richText"
      v-if="richText"
      :string="richText"
    />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  images: {
    type: Array
  },
  richText: {
    type: String,
    required: false
  }
})

const getAttributes = baseStrapiGetAttributes
</script>

<style module>
.root {
  --block--margin-bottom: calc(var(--unit--vertical) * 2);
}

[class*='components-core-blocks-rich-text'] + .root {
  --block--margin-top: calc(var(--unit--vertical) * 2);
}

.richText {
  composes: font-size-small from global;
  margin-top: var(--padding--element--top);
  padding-left: var(--unit--vertical);
  padding-right: var(--unit--vertical);
}
</style>
